import React from "react";
import Link from "../basic/link";
import Text from "../basic/text";
import Image from "../basic/image";
var BottomSection = function BottomSection(_ref) {
  var links = _ref.links,
    text = _ref.text,
    logo = _ref.logo,
    isMobile = _ref.isMobile;
  return /*#__PURE__*/React.createElement("div", {
    className: "footer__bottom-section"
  }, isMobile && /*#__PURE__*/React.createElement(Image, {
    src: logo.image.src,
    alt: logo.image.alt,
    width: logo.image.width,
    height: logo.image.height
  }), /*#__PURE__*/React.createElement("ul", {
    className: "footer__bottom-section__links"
  }, links.map(function (link, index) {
    return /*#__PURE__*/React.createElement("li", {
      key: "btm-link-".concat(index),
      className: "footer__bottom-section__links__item"
    }, /*#__PURE__*/React.createElement(Link, {
      content: link.link.content,
      href: link.link.href,
      target: link.link.target
    }));
  })), /*#__PURE__*/React.createElement(Text, {
    styleName: "footer__bottom-section__text",
    content: text[0].html.html
  }));
};
export default BottomSection;